import ContentLoader from 'react-content-loader'
import { colors } from '~/styles/colors'

export const OrderLoader = () => (
  <ContentLoader
    speed={2}
    width={862}
    height={215}
    viewBox="0 0 862 215"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    style={{
      border: colors.border,
      borderRadius: 2,
    }}
  >
    <rect x="40" y="50" rx="4" ry="4" width="450" height="24" />
    <rect x="40" y="82" rx="4" ry="4" width="150" height="15" />
    <rect x="740" y="52" rx="4" ry="4" width="85" height="30" />
    <rect x="755" y="96" rx="4" ry="4" width="70" height="15" />
  </ContentLoader>
)
